import React from 'react'
import { useBranding } from '@/contexts/BrandingContext'
import { cn } from '@/lib/utils'

interface ChatHeaderProps {
  title: string
  isLoading: boolean
  isOnline: boolean
  headerLeft?: React.ReactNode
  hideAiAvatar?: boolean
  onNewChat: () => void
  showInfo: boolean
  onToggleInfo: () => void
}

export function ChatHeader({
  title,
  isLoading,
  isOnline,
  headerLeft,
  hideAiAvatar,
  onNewChat,
  showInfo,
  onToggleInfo,
}: ChatHeaderProps) {
  const branding = useBranding()
  const subtitle = isLoading ? 'Thinking…' : isOnline ? 'Online' : 'Offline'

  return (
    // Same light chrome as the operator screens' headers.
    <div className="flex min-h-[60px] items-center justify-between border-b border-border bg-background px-4 py-2.5">
      {headerLeft && <div className="mr-2">{headerLeft}</div>}
      <div className="flex min-w-0 flex-1 items-center gap-2.5">
        {!hideAiAvatar && (
          <div
            className="flex size-9 shrink-0 items-center justify-center rounded-full"
            style={{ backgroundColor: branding.primaryColor }}
          >
            <span className="text-xs font-bold text-white">AI</span>
          </div>
        )}
        <div className="min-w-0">
          <p className="text-[15px] font-semibold text-foreground">{title}</p>
          <p className={cn('mt-px text-[11.5px] text-muted-foreground', !isOnline && 'font-semibold text-destructive')}>
            {subtitle}
          </p>
        </div>
      </div>
      <div className="flex gap-1.5">
        <button
          type="button"
          onClick={onNewChat}
          className="flex size-8 shrink-0 items-center justify-center rounded-full bg-muted transition-colors hover:bg-muted/70"
          aria-label="New chat"
        >
          <span className="text-base font-semibold leading-5 text-muted-foreground">+</span>
        </button>
        <button
          type="button"
          onClick={onToggleInfo}
          className="flex size-8 shrink-0 items-center justify-center rounded-full bg-muted transition-colors hover:bg-muted/70"
          style={showInfo ? { backgroundColor: branding.primaryColor } : undefined}
          aria-label="What can I do?"
        >
          <span className={cn('text-base font-semibold leading-5 text-muted-foreground', showInfo && 'text-white')}>
            i
          </span>
        </button>
      </div>
    </div>
  )
}
